import React from "react"
import PropTypes from "prop-types"
// Utilities
import kebabCase from "lodash/kebabCase"
// Components
import { Link, graphql } from "gatsby"
import Layout from "../components/Layout"
import SEOTAG from "../components/seotag"
import { SlugLink } from '../components/utils'
const TagsPage = ({
  data: {
    allMarkdownRemark: { group },
    site: {
      siteMetadata: { title, domainName },
    },
  },
  location
}) => {
  // if (location != null) {
  //   if (location.href != null && location.href.endsWith('/')) {
  //     window.location.href = window.location.href.substring(0, window.location.href.length - 1);
  //   }
  // }
  return (
    <Layout location={location} title={title}>
      <SEOTAG
        title={`All Category`}
        description={`All Category - ${domainName}`}
      />
      
      <div className="col-md-9">
        
          <h1>Category Page</h1>
          <ul>
            {group.map(tag => (
              <li key={tag.fieldValue}>
                <Link to={`/category/${SlugLink(kebabCase(tag.fieldValue))}`}>
                  {tag.fieldValue} ({tag.totalCount})
            </Link>
              </li>
            ))}
          </ul>
      </div>
    </Layout>
  )
}
TagsPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
}
export default TagsPage
export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        domainName
      }
    }
    allMarkdownRemark(limit: 2000) {
      group(field: frontmatter___category) {
        fieldValue
        totalCount
      }
    }
  }
`